import { fetchJson } from "@/services/api";
import { APP } from "@/config/app.config";
import type { PaginationMeta } from "@/types";

export interface ApiNotification {
  id: number;
  title: string;
  body: string;
  type: string;
  channel: string;
  notifiable_type: string;
  notifiable_id: number;
  metadata: Record<string, unknown>;
  created_at: string;
  scheduled_for: string | null;
}

export interface ApiNotificationStudent {
  id: number;
  uuid: string;
  student_code: string;
  first_name: string;
  last_name: string;
  avatar_url: string | null;
}

export interface ApiUserNotification {
  id: number;
  notification_id: number;
  user_id: number;
  is_read: boolean;
  student: ApiNotificationStudent | null;
  notification: ApiNotification;
  created_at: string;
  updated_at: string;
}

export interface NotificationsResponse {
  data: ApiUserNotification[];
  meta: PaginationMeta;
}

export async function getNotifications(
  page = 1,
  perPage = APP.pageSize,
): Promise<NotificationsResponse> {
  const params = new URLSearchParams({
    channel: "in_app",
    page: String(page),
    per_page: String(perPage),
  });
  return fetchJson<NotificationsResponse>(`/v1/notifications?${params}`);
}

export async function markNotificationAsRead(id: number): Promise<void> {
  return fetchJson(`/v1/notifications/${id}/read`, { method: "PATCH" });
}

export async function markAllNotificationsAsRead(): Promise<void> {
  return fetchJson(`/v1/notifications/read-all`, { method: "PATCH" });
}

export async function deleteNotification(id: number): Promise<void> {
  return fetchJson(`/v1/notifications/${id}`, { method: "DELETE" });
}

export interface NotificationSummary {
  unread_count: number;
  total_count: number;
  by_type: Record<string, number>;
}

export async function getNotificationSummary(): Promise<NotificationSummary> {
  const res = await fetchJson<{ data: NotificationSummary }>(
    "/v1/notifications/summary?channel=in_app",
  );
  return res.data;
}
